import { Record } from 'immutable';
import { UNKNOWN } from '../../common-message-format/constants/clientTypes';
import { NOT_DELETED } from '../../common-message-format/constants/messageDeleteStatus';
import { AUTO_REPLY_SUPPRESSED_MESSAGE } from '../constants/messageTypes';
const AutoReplySuppressedMessage = Record({
  '@type': AUTO_REPLY_SUPPRESSED_MESSAGE,
  id: '',
  timestamp: 0,
  messageDeletedStatus: NOT_DELETED,
  clientType: UNKNOWN,
  suppressedAutomatedType: '',
  senderName: null,
  senderEmail: null,
  emailSubject: null
}, 'AutoReplySuppressedMessage');
export default AutoReplySuppressedMessage;